var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.wrapperClasses},[_c('div',{class:_vm.spinnerClasses},[_c('Spin',{attrs:{"fix":""}},[_c('Icon',{class:_vm.iconClasses,attrs:{"type":"ios-loading","size":"18"}}),(_vm.text)?_c('div',{class:_vm.textClasses},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }